import { Trans, useTranslation } from "react-i18next";
import image from '../../img/About/goals.jpg';
import { useState } from "react";

const tabs = [
    {
        subtitle: 'about.goals.tab_01.subtitle',
        text: [
            'about.goals.tab_01.text_01',
            'about.goals.tab_01.text_02',
        ],
    },
    {
        subtitle: 'about.goals.tab_02.subtitle',
        text: [
            'about.goals.tab_02.text_01',
            'about.goals.tab_02.text_02',
        ],
    },
    {
        subtitle: 'about.goals.tab_03.subtitle',
        text: [
            'about.goals.tab_03.text_01',
            'about.goals.tab_03.text_02',
        ],
    },
];

const Goals = () => {
    const { t } = useTranslation();
    const [active, setActive] = useState(0);
    return (
        <section className="relative open-sans pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px]">
                <div className="relative">
                    <h2 className="md:hidden block text-[#0C2780] font-[700] text-[28px] xl:text-[45px]">
                        {t('about.goals.title')}
                    </h2>
                    <div className="relative md:absolute z-0 inset-0 xl:w-[695px] md:w-[calc(100%-525px)] w-[calc(100%+40px)] md:ml-0 ml-[-20px] md:mt-0 mt-[25px] md:mb-0 mb-[15px] overflow-hidden md:rounded-[20px] md:h-[100%] h-[235px]">
                        <img className="w-[100%] h-[100%] object-cover object-center" src={image} alt='' />
                    </div>
                    <div className="relative z-10 flex md:flex-col flex-col-reverse md:min-h-[495px] md:justify-between md:items-end gap-[25px]">
                        <div className="md:w-[495px]">
                            <h2 className="hidden md:block text-[#0C2780] font-[700] text-[28px] xl:text-[45px]">
                                {t('about.goals.title')}
                            </h2>
                            <p className="mt-0 md:mt-[30px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                                <Trans>
                                    {t(tabs[active].text[0])}
                                </Trans>
                            </p>
                            <p className="mt-[13px] md:mt-[15px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                                <Trans>
                                    {t(tabs[active].text[1])}
                                </Trans>
                            </p>
                        </div>
                        <div className="grid grid-cols-3 gap-[1px]">
                            {tabs.map((tab, index) =>
                                <div
                                    key={index}
                                    onClick={() => setActive(index)}
                                    className={`md:w-[226px] w-[100%] bg-[${active === index ? '#CFE0F2' : '#0C2780'}] select-none md:h-[118px] flex items-center justify-center md:justify-start md:px-[25px] px-[5px] md:py-[15px] py-[10px] duration-200 cursor-pointer`}
                                >
                                    <span className={`sm:text-[16px] text-[12px] text-[${active === index ? '#0C2780' : '#EFEFEF'}] font-[600] duration-200`}>
                                        {t(tab.subtitle)}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default Goals;
